@if (error) {
  <div class="p-3 rounded bg-danger text-white">
    @if (error.errorType) {
      <div class="d-flex justify-content-between">
        <div class="hyperion-t6">
          {{ languageService.getTranslation(getTranslationKey(error.errorType)) | async }}
        </div>
        <button
          class="btn btn-danger"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#error-collapse-more-info"
          aria-expanded="false"
          aria-controls="error-collapse-more-info"
          (click)="collapsed = !collapsed"
          >
          @if (collapsed) {
            Show
          } @else {
            Hide
          }
          More Information
          @if (collapsed) {
            <i class="bi bi-caret-up-fill"></i>
          } @else {
            <i class="bi bi-caret-down-fill"></i>
          }
        </button>
      </div>
    }
    <div class="collapse" id="error-collapse-more-info">
      @if (error.errorType) {
        <div class="hyperion-t6">Error: {{ error.errorType }}</div>
      }
      @if (error.additionalInfo) {
        <div class="hyperion-t6">Additional info: {{ error.additionalInfo }}</div>
      }
    </div>
  </div>
}
